import { render, staticRenderFns } from "./SignupSlider.vue?vue&type=template&id=463861f0&"
import script from "./SignupSlider.vue?vue&type=script&lang=js&"
export * from "./SignupSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports